export default __webpack_public_path__ + "media/images/map-favicon-e8af9a1621a11e32725cbd5d8cd8d6cc.png";